import {
    BudgetState,
    DashboardState,
    ExpenseState,
    FilterState,
    RootState,
    UserState,
    UsersState,
    ZipsState,
    AppState,
    PlantMappersState,
    RegionState,
    ManufacturesState,
    DistributorsState,
    HqfilterState,
    DistributorRepMapperState,
    GoalSettingsState,
    EndUserState,
    VerificationsState,
    HistoryState,
    DistributorManagers,
    ProductState,
    ForecastState,
    DealState,
    LargestDeals,
    RepresentativeActuals,
    RepresentativeHighGrossers,
    QuarterWiseRealisation,
    DealGraphData,
    MonthlyRealization,
    IDealState
} from 'types';

export const getUser = (state: RootState): UserState => state.userState;
export const getDashboard = (state: RootState): DashboardState =>
    state.dashboard;
export const getFilter = (state: RootState): FilterState => state.filter;
export const getExpense = (state: RootState): ExpenseState => state.expense;
export const getBudget = (state: RootState): BudgetState => state.budget;
export const getUsers = (state: RootState): UsersState => state.users;
export const getZips = (state: RootState): ZipsState => state.zips;
export const getMfgLookup = (state: RootState): any => state.mfgLookup;
export const getApp = (state: RootState): AppState => state.app;
export const getHeadwiseExpense = (state: RootState): ExpenseState =>
    state.expense;
export const getPlantMappers = (state: RootState): PlantMappersState =>
    state.plantMappers;
export const getTerritoryCodeMapperList = (state: RootState): any =>
    state.territoryCodeMapper;
export const getRegion = (state: RootState): RegionState => state.region;
export const getManufactures = (state: RootState): ManufacturesState =>
    state.manufactures;
export const getDistributors = (state: RootState): DistributorsState =>
    state.distributors;
export const getHqfilter = (state: RootState): HqfilterState => state.hqfilter;
export const getPipelinePartNumberMapper = (state: RootState): any =>
    state.PipelinePartNumberMapper;
export const getDistributorRepMapper = (
    state: RootState,
): DistributorRepMapperState => state.distributorRepMapper;
export const getGoalSettings = (state: RootState): GoalSettingsState =>
    state.goalSettings;
export const getEndUser = (state: RootState): EndUserState => state.endUser;
export const getVerifications = (state: RootState): VerificationsState =>
    state.verifications;
export const getHistory = (state: RootState): HistoryState => state.history;
export const getDistributorManagers = (state: RootState): DistributorManagers =>
    state.distributorManagers;
export const getProducts = (state: RootState): ProductState => state.products;
export const getForecasts = (state: RootState): ForecastState =>
    state.forecasts;
export const getDeals = (state: RootState): DealState => state.dealsState;
export const getLargestDeals = (state: RootState): [LargestDeals] =>
    state?.dealsState?.largestDeals;
export const getHighestActuals = (state: RootState): [RepresentativeActuals] =>
    state?.dealsState?.highestActuals;
export const getLowestActuals = (state: RootState): [RepresentativeActuals] =>
    state?.dealsState?.lowestActuals;
export const getHighestGrossers = (
    state: RootState,
): [RepresentativeHighGrossers] => state?.dealsState?.highestGrossers;
export const getQuarterWiseData = (
    state: RootState,
): [QuarterWiseRealisation] => state?.dealsState?.quarterWiseData;
export const getYTDDealToSales = (state: RootState): [DealGraphData] =>
    state?.dealsState?.ytdDealToSales;
export const getYearComparisonData = (state: RootState): [DealGraphData] =>
    state?.dealsState?.yearComparisonData;
export const getMonthlyRealisation = (state: RootState): [MonthlyRealization] =>
    state?.dealsState?.monthlyRealisation;
export const getSelectedRow = (state: RootState): IDealState =>
    state?.dealsState?.selectedRow;
export const getSelectedRowKey = (state: RootState): Array<number> =>
    state?.dealsState?.selectedRowKey;

export const getSchedulers = (state: RootState): any => state.schedulers;